import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RolloverFormFactory } from './rollover-form.factory';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CalculationStore } from '../../../../../stores/calculation.store';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';
import {
  RolloverShareClassesFormComponent,
} from '../rollover-share-classes-form/rollover-share-classes-form.component';
import { RolloverPropertiesFormComponent } from '../rollover-properties-form/rollover-properties-form.component';
import { AlertMessageStore } from '../../../../../../core/stores/alert-message.store';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { CalculationBaseForm } from '../../../base-form/form/base-form/calculation-base.form';
import { CalculationsUtils } from '../../../../../utils/calculations.utils';
import { ImportManager } from '../../../../../managers/import.manager';
import {
  CalculationKeynameEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { FormChangeManager } from '../../../../../managers/form-change.manager';
import { CalculationLifecycleManager } from '../../../../../managers/calculation-lifecycle.manager';
import { EventManager } from '../../../../../../core/managers/event.manager';


@Component({
  selector: 'app-rollover-form',
  templateUrl: './rollover-form.component.html',
  styleUrls: ['./rollover-form.component.scss'],
  standalone: false,
})
export class RolloverFormComponent extends CalculationBaseForm<RolloverOptions> implements OnInit, OnDestroy {

  isExecuteButtonEnabled: boolean = false;

  @ViewChild('shareClasses')
  shareClassesComponent: RolloverShareClassesFormComponent;
  @ViewChild('properties')
  propertiesComponent: RolloverPropertiesFormComponent;

  constructor(public readonly formFactory: RolloverFormFactory,
              calculationStore: CalculationStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              private readonly changeDetectorRef: ChangeDetectorRef,
              importManager: ImportManager,
              calculationLifecycleManager: CalculationLifecycleManager,
              formChangeManager: FormChangeManager,
              eventManager: EventManager,
  ) {
    super(formFactory, calculationStore, translateService, activatedRoute, modalService, router, optionsMapper, calculationsUtils, alertMessageStore, CalculationKeynameEnum.Rollover, importManager, calculationLifecycleManager, formChangeManager,
      eventManager);
    this.optionsType = RolloverOptions;
  }

  get buyerCorporation(): AdvancedFormControl<string, string, string> {
    return this.form.formElements.buyerCorporation as AdvancedFormControl<string, string, string>;
  }

  get propertiesTransferred(): AdvancedFormArray<RolloverPropertyTransferredOptions> {
    return this.form.formElements.propertiesTransferred as AdvancedFormArray<RolloverPropertyTransferredOptions>;
  }

  get productionDeadline(): AdvancedFormControl<NgbDateStruct, NgbDateStruct, Date> {
    return this.form.formElements.productionDeadline as AdvancedFormControl<NgbDateStruct, NgbDateStruct, Date>;
  }

  get signatureDate(): AdvancedFormControl<NgbDateStruct, NgbDateStruct, Date> {
    return this.form.formElements.signatureDate as AdvancedFormControl<NgbDateStruct, NgbDateStruct, Date>;
  }

  postUpdateCallback() {
    super.postUpdateCallback();
    this.formFactory.init(this.form);
  }

  override refresh() {
    // this.propertiesComponent.refresh();
    // this.shareClassesComponent.refresh();
    // this.changeDetectorRef.detectChanges();
  }

}
